import { render, staticRenderFns } from "./BuildingsView.vue?vue&type=template&id=22d1e7c9"
import script from "./BuildingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildingsView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports